export default __webpack_public_path__ + "static/media/square-right.3c487b8a.svg";